import { ChangeEvent } from 'react';
import { Controller, Control } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';
import { SwitchProps, Switch, FormControlLabel } from '@mui/material';

export type InputSwitchProps = Omit<SwitchProps, 'value' | 'checked'> & {
  name: string;
  label: string;
  control: Control<any>;
  onChangeCallback?: (event: ChangeEvent) => void;
  /** Classes do `FormControlLabel`. */
  labelClassName?: string;
};

export const InputSwitch = ({
  name,
  label,
  control,
  onChangeCallback,
  defaultChecked,
  labelClassName,
  ...restProps
}: InputSwitchProps) => {
  const SwitchStyles = '';

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultChecked ?? control._defaultValues[name]}
      render={({ field }) => {
        const handleChange = (
          event: ChangeEvent<HTMLInputElement>,
          checked: boolean,
        ) => {
          field.onChange(checked);
          onChangeCallback?.(event);
        };

        return (
          <FormControlLabel
            control={
              <Switch
                {...restProps}
                onChange={handleChange}
                checked={Boolean(field.value)}
                inputProps={{ id: name }}
                className={twMerge(SwitchStyles, restProps.className)}
              />
            }
            label={label}
            className={labelClassName}
          />
        );
      }}
    />
  );
};
